import React from "react";
import CustomDropdownSelect from "src/business-types/grocery/components/DropdownSelect";

interface FilterSelectProps {
  selectedOption: string;
  handleFilterChange: (value: string) => void;
}

const DATE_OPTIONS = [
  { _id: "Today", CategoryName: "Today" },
  { _id: "Yesterday", CategoryName: "Yesterday" },
  { _id: "LastWeek", CategoryName: "Last 7 days" },
  { _id: "LastMonth", CategoryName: "Last 30 days" },
  { _id: "180days", CategoryName: "Last 180 days" },
  { _id: "CustomizeDate", CategoryName: "Customize date" },
];

const FilterSelect: React.FC<FilterSelectProps> = ({
  selectedOption,
  handleFilterChange,
}) => {
  return (
    <CustomDropdownSelect
      // title="Choose an Date Range:"
      title="Date Range:"
      titleClassName="font-bold"
      name="dateOption"
      value={selectedOption}
      options={DATE_OPTIONS}
      onChange={handleFilterChange}
      className="!mb-0 w-full"
    />
  );
};

export default FilterSelect;